<template>
  <md-toolbar id="sticky-toolbar" class="flex: 1">
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $t('title.' + $route.name) }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          :class="{ toggled: $sidebar.showSidebar }"
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-autocomplete">
            <md-autocomplete
              v-model="selectedAction"
              :md-options="actions"
              :md-open-on-focus="true"
              class="search"
            >
              <label>{{ $t('common.search') + '...' }}</label>
            </md-autocomplete>
          </div>
          <md-list>
            <li class="md-list-item">
              <a
                href="javascript:void(0)"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <i
                        v-if="$i18n.locale === 'fr'"
                        class="flag-icon flag-icon-fr"
                      ></i>
                      <i v-else class="flag-icon flag-icon-gb"></i>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <client-only>
                        <li
                          v-for="locale in availableLocales"
                          :key="locale.code"
                        >
                          <nuxt-link :to="switchLocalePath(locale.code)">
                            <i
                              :class="'flag-icon flag-icon-' + locale.icon"
                            ></i>
                            {{ $t('common.lang.' + locale.code) }}
                          </nuxt-link>
                        </li>
                      </client-only>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item :to="localePath('dashboard-activity')">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">
                {{ $t('dashboard.sidebar.dashboard') }}
              </p>
            </md-list-item>

            <li class="md-list-item">
              <a
                href="javascript:void(0)"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div
                  v-if="notificationsTotalCount && notificationsTotalCount > 0"
                  class="md-list-item-content"
                >
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications</md-icon>
                      <span class="notification">{{
                        notificationsTotalCount
                      }}</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li
                        v-if="
                          notificationsSessionsToValidateCount &&
                            notificationsSessionsToValidateCount > 0
                        "
                      >
                        <nuxt-link
                          :to="
                            localePath({
                              name: 'activity-sessions-history',
                              query: { validate: 'true' }
                            })
                          "
                          >{{
                            $t('header.notifications_sessions_to_validate', {
                              notifCount: notificationsSessionsToValidateCount
                            })
                          }}</nuxt-link
                        >
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item href="javascript:void(0)" @click="logout()">
              <i class="material-icons">exit_to_app</i>
              <p class="hidden-lg hidden-md">{{ $t('sidebar.logout') }}</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      list: [{ code: 'fr' }, { code: 'en' }],
      selectedAction: '',
      actions: [
        this.$t('dashboard.sidebar.dashboard') +
          ' - ' +
          this.$t('dashboard.sidebar.progress_activity_title'),
        this.$t('dashboard.sidebar.dashboard') +
          ' - ' +
          this.$t('dashboard.sidebar.progress_title'),
        this.$t('dashboard.sidebar.dashboard') +
          ' - ' +
          this.$t('dashboard.next_courses'),
        this.$t('dashboard.sidebar.dashboard') +
          ' - ' +
          this.$t('dashboard.sidebar.progress_seo_title'),
        this.$t('dashboard.sidebar.dashboard') +
          ' - ' +
          this.$t('dashboard.sidebar.progress_customer_title'),
        this.$t('dashboard.sidebar.dashboard') +
          ' - ' +
          this.$t('dashboard.sidebar.progress_seo_goyoga'),
        this.$t('dashboard.sidebar.dashboard') +
          ' - ' +
          this.$t('dashboard.sidebar.progress_seo_gotherapy'),
        this.$t('dashboard.sidebar.dashboard') +
          ' - ' +
          this.$t('dashboard.sidebar.progress_seo_gopilates')
      ]
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'loggedInUser']),
    ...mapGetters('session', [
      'getCurrentUserSessionsToValidate',
      'getCurrentCenterSessionsToValidate'
    ]),
    notificationsSessionsToValidateCount() {
      return (
        (this.getCurrentUserSessionsToValidate &&
          this.getCurrentUserSessionsToValidate.count) +
        (this.getCurrentCenterSessionsToValidate &&
          this.getCurrentCenterSessionsToValidate.count)
      )
    },
    notificationsTotalCount() {
      return this.notificationsSessionsToValidateCount
    },
    availableLocales() {
      return this.$i18n.locales.filter((i) => i.code !== this.$i18n.locale)
    }
  },
  watch: {},
  mounted() {},
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    async logout() {
      await this.$auth.logout()
      window.location.href = '/'
    }
  }
}
</script>

<style>
.main-panel > .md-toolbar .md-title {
  color: #555 !important;
}
.main-panel > #sticky-toolbar {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  opacity: 0.9;
  background-color: #eee !important;
}
</style>
